var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stakewait"},[_c('div',[_vm._v(" 合约广场 ")]),(_vm.isloading)?_c('div',{staticClass:"loading"},[_c('img',{staticClass:"loadimg",attrs:{"src":_vm.loadingimg}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }